import { FC } from 'react';
import * as ToggleGroup from '@radix-ui/react-toggle-group';

import { SoundDemoClipComponentProps } from 'components/Product/SoundDemo/soundDemoTypes';
import useFallbackTranslation from 'utils/hooks/useFallbackTranslation';

export const SoundDemoClipToggleGroup: FC<SoundDemoClipComponentProps> = ({
  SoundDemoEnvironment,
  setSelectedDemoClip,
}) => {
  const { t } = useFallbackTranslation();
  return (
    <ToggleGroup.Root
      aria-label={t('system.TryTheFeatures')}
      role="radiogroup"
      type="single"
      key={SoundDemoEnvironment.id}
      className="flex gap-12"
      defaultValue={SoundDemoEnvironment.SoundDemoClips[0].SoundDemoName?.value}
      onValueChange={(value) => setSelectedDemoClip(value)}
    >
      {SoundDemoEnvironment.SoundDemoClips.map((clip) => (
        <ToggleGroup.Item
          value={clip.SoundDemoName?.value}
          className="rounded-full px-6 py-2 text-base uppercase data-[state=on]:bg-yellow data-[state=on]:text-black"
          key={clip.id}
        >
          <label>{clip.SoundDemoName?.value}</label>
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
};
